class FooterMenu extends HTMLElement {
  constructor() {
    super();
    this.query = window.matchMedia('(min-width: 1200px)');
    this.onChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.query.addEventListener('change', this.onChange);
    this.handleChange();
  }

  disconnectedCallback() {
    this.query.removeEventListener('change', this.onChange);
  }

  // Columns are always expanded on desktop, collapsed accordions on mobile.
  handleChange() {
    const isDesktop = this.query.matches;

    this.querySelectorAll('details').forEach((details) => {
      details.open = isDesktop;
    });
  }
}

if (!customElements.get('footer-menu')) {
  customElements.define('footer-menu', FooterMenu);
}
